const svgNS = 'http://www.w3.org/2000/svg';

// HELPER FUNCTIONS:

// trova il rigo alto piu' vicino data una coordinata verticale.
export const findCurrentTopLine = (svgCanvas, referenceHeight) => {
  const topList = svgCanvas.querySelectorAll('.abcjs-top-of-system');
  let selectedTop = null;
  if(topList.length === 1) return topList[0];
  for (let topCounter = 0; topCounter < topList.length; topCounter++) {
    if (
      referenceHeight > topList[topCounter].getBBox().y &&
      (selectedTop === null || topList[topCounter].getBBox().y > selectedTop.getBBox().y)
    )
      selectedTop = topList[topCounter];
  }
  return selectedTop;
};

// find note length from abcjs style classlist.
const retrieveNoteLengthFromClassList = svgNoteElement => {
  let noteLength = svgNoteElement.classList.value.split(' ').filter(s => {
    return s.indexOf('abcjs-d') !== -1;
  });
  if (noteLength.length) {
    noteLength = noteLength[0].replace('abcjs-d', '').replace('-', '.');
  }
  return noteLength;
};

// DRAWING STUFF

// draw a black contour around the given note.
export const drawNoteBoundingBox = (abcjsSvgPaper, svgNoteElement) => {
  const { x, y, width, height } = svgNoteElement.getBBox();
  const attrs = {
    x: x - 2,
    y: y - 2,
    width: width + 4,
    height: height + 4,
    fill: '#ffffff00',
    stroke: '#000000'
  };
  const box = abcjsSvgPaper.rect(attrs);
  box.setAttribute('class', 'box-cursor');
  svgNoteElement.parentElement.append(box);
};

// draw a triangle above the given note.
export const drawTriangleAboveNote = (svgCanvas, abcjsSvgPaper, svgNoteElement) => {
  const { x, y, width } = svgNoteElement.getBBox();
  const middleX = x + width / 2;
  const topLineElement = findCurrentTopLine(svgCanvas, y);
  const topY = topLineElement.getBBox().y - 5;
  const attrs = {
    path: `m ${middleX} ${topY} l -5 -5 l 10 0z`,
    fill: '#000000',
    stroke: '#000000'
  };
  const triangle = abcjsSvgPaper.path(attrs);
  triangle.setAttribute('class', 'arrow-cursor');
  svgNoteElement.parentElement.append(triangle);
};

export const makeTriangleOverBar = (svgCanvas, abcjsSvgPaper, line, measure, fill, onClick) => {
  const barElement = svgCanvas.querySelector(`.abcjs-bar.abcjs-m${measure}.abcjs-l${line}`);
  if (barElement) {
    const { x, y } = barElement.getBBox();
    const attrs = {
      path: `m ${x} ${y - 5} l -5 -5 l 10 0z`,
      stroke: '#eb6075',
      fill: fill ? fill : '#ffffff00'
    };
    const triangle = abcjsSvgPaper.path(attrs);
    triangle.classList.add('abcjs-bar-selection-element');
    if (onClick) triangle.addEventListener('click', onClick);
    barElement.parentElement.insertBefore(triangle, barElement);
  }
};

// Write a text above the given note
export const drawNoteNameAboveNote = (abcjsCanvas, abcjsSvgPaper, svgNoteElement, text) => {
  const { x, y } = svgNoteElement.getBBox();
  const selectedTop = findCurrentTopLine(abcjsCanvas, y);

  const noteName = abcjsSvgPaper.text(text, {
    x: x,
    y: selectedTop.getBBox().y,
    'font-weight': 'bold',
    fill: 'blue'
  });
  noteName.classList.add('drawed-by-drawNoteNameAboveNote');
  svgNoteElement.parentElement.insertBefore(noteName, svgNoteElement);
};

// draw a rectangle between two bars, according to the current measure's beat
export const drawRectBetweenBars = (
  svgCanvas,
  abcjsSvgPaper,
  firstBarSvgElement,
  secondBarSvgElement,
  beatsPerBar,
  barQuarter
) => {
  const { x, y } = firstBarSvgElement.getBBox();
  const { x: secondX, y: secondHeight } = secondBarSvgElement.getBBox();
  const attrs = {
    x: x,
    y: y,
    width: ((secondX - y) / beatsPerBar) * barQuarter,
    height: secondHeight,
    fill: '#FF507388'
  };
  svgCanvas.querySelectorAll('.drawed-by-drawRectBetweenBars').forEach(e => e.remove());
  const lastBarElement1 = abcjsSvgPaper.rect(attrs);
  lastBarElement1.classList.add('drawed-by-drawRectBetweenBars');
  firstBarSvgElement.parentElement.insertBefore(lastBarElement1, firstBarSvgElement);
};

// draw balls between two bars, according to the current measure's beat.
export const drawBallsBelowBars = (svgCanvas, abcjsSvgPaper, barPath, nextBarPath, beatsPerBar, barQuarter) => {
  svgCanvas.querySelectorAll('.drawed-by-drawBallsBelowBars').forEach(e => e.remove());

  const group_attrs = {
    style: 'stroke:#969696;stroke-width:2px;fill:#545454;'
  };
  const cirlesGroupSvgElement = abcjsSvgPaper.openGroup();
  for (const key in group_attrs) {
    if (group_attrs.hasOwnProperty(key)) {
      cirlesGroupSvgElement.setAttributeNS(null, key, group_attrs[key]);
    }
  }
  for (let i = 0; i < barQuarter; i++) {
    const currBox = barPath.getBBox();
    const nextBox = nextBarPath.getBBox();
    const circle_attr = {
      cx: currBox.x + ((nextBox.x - currBox.x) / beatsPerBar) * (i + 0.5),
      cy: currBox.y + nextBox.height + 20,

      r: Math.min('5', (nextBox.x - currBox.x) / beatsPerBar / 2)
    };
    const circle = document.createElementNS(svgNS, 'circle');
    for (const key in circle_attr) {
      if (circle_attr.hasOwnProperty(key)) {
        circle.setAttributeNS(null, key, circle_attr[key]);
      }
    }

    cirlesGroupSvgElement.classList.add('drawed-by-drawBallsBelowBars');
    cirlesGroupSvgElement.append(circle);
  }
  abcjsSvgPaper.closeGroup();
  barPath.parentElement.insertBefore(cirlesGroupSvgElement, barPath);
};

export const drawLengthSquaresOverNote = (svgCanvas, abcjsSvgPaper, svgNoteElement) => {
  const { x, y, width } = svgNoteElement.getBBox();
  let selectedTop = findCurrentTopLine(svgCanvas, y);
  if(!selectedTop){
    console.log(svgNoteElement.classList, svgCanvas, y);
    return;
  }
  // draw rect
  let noteLength = retrieveNoteLengthFromClassList(svgNoteElement);
  const squaresGroup = abcjsSvgPaper.openGroup();

  // numero di ottavi. (con note a un sedicesimo che si fa?)
  for (let i = 0; i < Number(noteLength) / 0.25; i++) {
    // build path attributes:
    let squareHeight = 5;
    if (Number(noteLength) < 0.25) {
      squareHeight = 5 / (0.25 / Number(noteLength));
    }

    const attrs = {
      x: x + width / 2,
      y: selectedTop.getBBox().y - squareHeight - squareHeight * i,
      width: 5,
      height: squareHeight,
      fill: '#969696',
      stroke: '#ffffff'
    };
    attrs.y -= attrs.height;
    const square = abcjsSvgPaper.rect(attrs);
    square.classList.value = svgNoteElement.classList.value;
    square.classList.remove('abcjs-note');
    square.classList.add('abcjs-square');
    squaresGroup.append(square);
  }
  squaresGroup.setAttribute('class', 'abcjs-square-group');
  svgNoteElement.parentElement.insertBefore(squaresGroup, svgNoteElement);
};

export const drawLengthSquaresOverAll = (svgCanvas, abcjsSvgPaper) => {
  const notes = svgCanvas.querySelectorAll('.abcjs-note');
  notes.forEach(path => {
    drawLengthSquaresOverNote(svgCanvas, abcjsSvgPaper, path);
  });
  const rests = svgCanvas.querySelectorAll('.abcjs-rest');
  rests.forEach(path => {
    drawLengthSquaresOverNote(svgCanvas, abcjsSvgPaper, path);
  });
};
